import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ConfirmRegistrationComponent } from './confirm-registration/confirm-registration.component';
import { LogoutComponent } from './logout/logout.component';
import { NewsComponent } from './news/news.component';
import { ContactusComponent } from './contactus/contactus.component';
import { LegalComponent } from './legal/legal.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ApplicantLandingComponent } from './applicant-landing/applicant-landing.component';
import { ApplicantLearnmoreComponent } from './applicant-learnmore/applicant-learnmore.component';
import { ProctorLandingComponent } from './proctor-landing/proctor-landing.component';
import { ProctorLearnmoreComponent} from './proctor-learnmore/proctor-learnmore.component';
import { SampleQuestionsPreComponent } from './sample-questions-pre/sample-questions-pre.component';
import { SampleQuestionsComponent } from '../ui-testrunner/sample-questions/sample-questions.component';
import { AttestationComponent } from './attestation/attestation.component';
import { G9SampleTestComponent } from './g9-sample-test/g9-sample-test.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: ':accountType/login', component: LoginComponent },
  { path: ':accountType/login/:dontLogout', component: LoginComponent },
  { path: ':accountType/login/:emailEncoded', component: LoginComponent, pathMatch: 'full' },
  { path: ':accountType/login/:emailEncoded/:dontLogout', component: LoginComponent },
  { path: ':accountType/forgot-password', component: ForgotPasswordComponent },
  { path: 'password-reset/:emailEncoded/:resetKey', component: PasswordResetComponent},
  { path: 'activate-account/:emailEncoded/:activationKey', component: ConfirmRegistrationComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'news', component: NewsComponent },
  { path: 'contact', component: ContactusComponent },
  { path: 'legal', component: LegalComponent },
  { path: 'g9-sample', component: G9SampleTestComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'attestation', component: AttestationComponent },
  // { path: 'applicant/landing', component: ApplicantLandingComponent }, //comment out before pushing
  { path: 'applicant/learn/:topicPath', component: ApplicantLearnmoreComponent, pathMatch: 'full' },
  {
    path: 'testadmin',
    children: [
      // {
      //   path: 'landing', component: ProctorLandingComponent //comment out before pushing
      // },
      {
        path: 'learn/:topicPath', component: ProctorLearnmoreComponent
      }
    ]
  },
  { path: 'sample-questions-pre', component: SampleQuestionsPreComponent },
  { path: 'sample-questions', component: SampleQuestionsComponent },
  { path: 'sample-questions/:practiceNum', component: SampleQuestionsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UiLandingRoutingModule { }
